/**
 * Mobile product inquiry — fetch POST (no top-level JSON page).
 * form[target=iframe] is a safety net if native submit ever fires.
 */
(function () {
  var CAPTCHA_GRACE_MS = 2500;
  var SUBMIT_TIMEOUT_MS = 30000;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getQty() {
    var qty =
      qs('[data-pm-qty]') ||
      qs('product-info input[name="quantity"]') ||
      qs('form[action*="/cart/add"] input[name="quantity"]') ||
      qs('input[name="quantity"]');
    var n = qty ? parseInt(qty.value || '1', 10) : 1;
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function hasCaptchaToken(form) {
    var names = ['h-captcha-response', 'g-recaptcha-response', 'recaptcha-v3-token'];
    for (var i = 0; i < names.length; i++) {
      var input = form.elements[names[i]];
      if (input && String(input.value || '').trim()) return true;
    }
    return false;
  }

  function looksLikeSuccess(url, text) {
    var blob = String(url || '') + '\n' + String(text || '');
    return (
      /contact_posted=true/i.test(blob) ||
      /"inquiry-sent"|data-inquiry-sent|inquiry-sent-confirm/i.test(blob) ||
      /Thanks for contacting us|Thanks for contacting|Thank you for your message|感謝您聯絡|感谢您联系/i.test(blob)
    );
  }

  function looksLikeError(text) {
    if (!text) return false;
    return /Please adjust the following|contact\.form\.error|400 Bad Request|Captcha verification failed/i.test(text);
  }

  function protectForm(form, callback) {
    var shopify = window.Shopify;
    if (shopify && shopify.captcha && typeof shopify.captcha.protect === 'function') {
      try {
        shopify.captcha.protect(form, callback);
        return;
      } catch (err) {}
    }
    window.setTimeout(callback, 0);
  }

  function ensureCaptchaReady(form) {
    return new Promise(function (resolve) {
      protectForm(form, function () {
        if (hasCaptchaToken(form)) {
          resolve();
          return;
        }
        var start = Date.now();
        var timer = window.setInterval(function () {
          if (hasCaptchaToken(form) || Date.now() - start >= CAPTCHA_GRACE_MS) {
            window.clearInterval(timer);
            resolve();
          }
        }, 100);
      });
    });
  }

  function buildInquiryBody(form, modal) {
    var bodyField = form.elements['contact[body]'];
    if (!bodyField) return;

    var userMessage = String(bodyField.value || '').trim();
    var title = modal.getAttribute('data-product-title') || '';
    var url = modal.getAttribute('data-product-url') || window.location.href;
    var sku = modal.getAttribute('data-product-sku') || '';
    var qtyField = qs('[data-inquiry-hidden-qty]', modal);
    var qty = qtyField ? qtyField.value : getQty();
    var name = form.elements['contact[name]'] ? form.elements['contact[name]'].value : '';
    var email = form.elements['contact[email]'] ? form.elements['contact[email]'].value : '';
    var country = form.elements['contact[country]'] ? form.elements['contact[country]'].value : '';
    var phone = form.elements['contact[phone]'] ? form.elements['contact[phone]'].value : '';

    bodyField.value = [
      'Product Inquiry',
      'Product: ' + title,
      'URL: ' + url,
      'SKU: ' + sku,
      'Quantity: ' + qty,
      'Name: ' + name,
      'Email: ' + email,
      'Country: ' + country,
      'Phone: ' + phone,
      '',
      userMessage
    ].join('\n');
  }

  function submitViaFetch(form) {
    var action = form.getAttribute('action') || '/contact';
    var fd = new FormData(form);
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, SUBMIT_TIMEOUT_MS);

    return fetch(action, {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      redirect: 'follow',
      signal: controller ? controller.signal : undefined,
      headers: {
        Accept: 'application/json, text/html, */*;q=0.01',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (res) {
        return res.text().then(function (text) {
          return { ok: res.ok, status: res.status, text: text, url: res.url || '' };
        });
      })
      .then(function (result) {
        window.clearTimeout(timer);
        if (looksLikeError(result.text)) throw new Error('validation');
        if (looksLikeSuccess(result.url, result.text)) return;
        if (result.ok || (result.status >= 200 && result.status < 400)) {
          if (/inquiry-sent|contact_posted|Thanks for contacting/i.test(result.text + result.url)) return;
        }
        throw new Error('submit failed');
      })
      .catch(function (err) {
        window.clearTimeout(timer);
        if (err && err.name === 'AbortError') throw new Error('timeout');
        throw err;
      });
  }

  function init() {
    var openBtns = qsa('[data-inquiry-open]');
    var modal = qs('[data-inquiry-modal]');
    if (!openBtns.length || !modal) return;

    var closeBtn = qs('[data-inquiry-close]', modal);
    var qtyPreview = qs('[data-inquiry-qty-preview]', modal);
    var hiddenQty = qs('[data-inquiry-hidden-qty]', modal);
    var form = qs('#ProductInquiryContactForm', modal) || qs('form', modal);
    var iframe = qs('[data-inquiry-iframe]', modal);
    var successBox = qs('[data-inquiry-success]', modal);
    var errorBox = qs('[data-inquiry-error]', modal);
    var loadingBox = qs('[data-inquiry-loading]', modal);
    var submitBtn = qs('[data-inquiry-submit]', modal);
    var submitLabel = qs('[data-inquiry-submit-label]', modal);

    if (!form) return;

    // Safety: never navigate the top window if native submit fires.
    if (iframe && iframe.getAttribute('name')) {
      form.setAttribute('target', iframe.getAttribute('name'));
    }

    var lastActive = null;
    var isSubmitting = false;
    var defaultSubmitLabel = submitLabel ? submitLabel.textContent : 'Send Inquiry';
    var defaultLoadingText = loadingBox ? loadingBox.textContent : '';
    var defaultErrorText = errorBox ? errorBox.textContent : '';

    function setLoading(active) {
      if (loadingBox) loadingBox.classList.toggle('is-visible', active);
      if (submitBtn) {
        submitBtn.disabled = active;
        submitBtn.classList.toggle('is-loading', active);
        submitBtn.setAttribute('aria-busy', active ? 'true' : 'false');
      }
      if (submitLabel) submitLabel.textContent = active ? 'Sending…' : defaultSubmitLabel;
    }

    function setLoadingMessage(message) {
      if (loadingBox && message) loadingBox.textContent = message;
    }

    function resetLoadingMessage() {
      if (loadingBox && defaultLoadingText) loadingBox.textContent = defaultLoadingText;
    }

    function resetSubmitState() {
      isSubmitting = false;
      resetLoadingMessage();
      setLoading(false);
    }

    function showSuccess() {
      isSubmitting = false;
      resetLoadingMessage();
      if (loadingBox) loadingBox.classList.remove('is-visible');
      if (errorBox) errorBox.classList.remove('is-visible');
      if (successBox) successBox.classList.add('is-visible');
      setLoading(false);
      try {
        form.reset();
      } catch (e) {}
      window.setTimeout(close, 2200);
    }

    function showError(message) {
      resetSubmitState();
      if (errorBox) {
        errorBox.textContent = message || defaultErrorText;
        errorBox.classList.add('is-visible');
      }
    }

    function open() {
      lastActive = document.activeElement;
      var q = getQty();
      if (hiddenQty) hiddenQty.value = String(q);
      if (qtyPreview) qtyPreview.textContent = 'Quantity: ' + q;
      if (successBox) successBox.classList.remove('is-visible');
      if (errorBox) errorBox.classList.remove('is-visible');
      if (loadingBox) loadingBox.classList.remove('is-visible');
      resetSubmitState();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
      document.body.classList.add('no-scroll');
      if (closeBtn) closeBtn.focus();
      protectForm(form, function () {});
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
      document.body.classList.remove('no-scroll');
      resetSubmitState();
      if (lastActive && lastActive.focus) lastActive.focus();
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (isSubmitting) return;
        close();
      });
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal && !isSubmitting) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape' && !isSubmitting) close();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isSubmitting) return;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      isSubmitting = true;
      if (successBox) successBox.classList.remove('is-visible');
      if (errorBox) errorBox.classList.remove('is-visible');
      setLoading(true);
      setLoadingMessage('Preparing your inquiry…');

      buildInquiryBody(form, modal);

      ensureCaptchaReady(form)
        .then(function () {
          setLoadingMessage('Sending your inquiry… Please wait.');
          return submitViaFetch(form);
        })
        .then(function () {
          showSuccess();
        })
        .catch(function (err) {
          var msg = err && err.message;
          if (msg === 'validation') {
            showError('Something went wrong. Please check your details and try again.');
            return;
          }
          if (msg === 'timeout') {
            showError('The request took too long. Please try again, or email sales@plcprotech.com.');
            return;
          }
          showError('Unable to send right now. Please try again, or email sales@plcprotech.com.');
        });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
